function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "prototype",
  transform: "translate(0.2 0.2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M22.191,26a.762.762,0,0,1-.761-.761v-.762H4.57v.762A.762.762,0,0,1,3.809,26H.761A.762.762,0,0,1,0,25.239V22.191a.762.762,0,0,1,.761-.761h.762V4.57H.761A.762.762,0,0,1,0,3.809V.761A.762.762,0,0,1,.761,0H3.809A.762.762,0,0,1,4.57.761v.762H21.43V.761A.762.762,0,0,1,22.191,0h3.047A.762.762,0,0,1,26,.761V3.809a.762.762,0,0,1-.761.761h-.762V21.43h.762a.762.762,0,0,1,.761.761v3.047a.762.762,0,0,1-.761.761Z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M0,12.9a1.717,1.717,0,0,1,.2-.8.057.057,0,0,1,0-.006L6.045.415a.739.739,0,0,1,1.328,0l5.844,11.678,0,.006a1.726,1.726,0,0,1,.2.8c0,2.365-4.343,3.038-6.71,3.038S0,15.263,0,12.9Z",
  transform: "translate(6.71 5.871)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.4
}));

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.4,
    height: 26.4,
    viewBox: "0 0 26.4 26.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.74ce5bca.svg";
export { ForwardRef as ReactComponent };